import React from 'react';
import PropTypes from 'prop-types';
import { connect } from 'react-redux';

class ModalRoot extends React.Component {

  render() {
    const { modalName, modalProps, ActiveModal } = this.props.rootModal;
    if (!ActiveModal) {
      return null;
    }
    return (
      <ActiveModal modalName={modalName} {...modalProps} />
    );
  }

}

ModalRoot.propTypes = {
  rootModal: PropTypes.object
};

export default connect(state => ({
  rootModal: state.componentReducer.rootModal
}))(ModalRoot);



// WEBPACK FOOTER //
// ./src/components/Modals/index.js